module.exports = {
  formatReceiptNumber: formatReceiptNumber,
  formatMonth: formatMonth,
  formatDate: formatDate,
  formatCompactDate: formatCompactDate,
  formatPhone: formatPhone,
  formatPrice: formatPrice,
  formatStars: formatStars,
  formatBidAvailability: formatBidAvailability,
  formatTransportationId: formatTransportationId,
  formatDeliveryId: formatDeliveryId,
  formatFixedJobId: formatFixedJobId,
  formatRelativeDate: formatRelativeDate,
  formatPaymentMethod: formatPaymentMethod,
  formatWeekDay: formatWeekDay
};
var months = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];
var weekDays = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
function formatReceiptNumber(rawNumber, year, typeKey) {
  var f = function f(num) {
    return Math.floor(num).toLocaleString(undefined, {
      maximumFractionDigits: 0,
      minimumIntegerDigits: 3
    });
  };
  return "ES-" + typeKey + "-" + year + "-" + f(rawNumber / 1000000) + "-" + f(rawNumber / 1000 % 1000) + "-" + f(rawNumber % 1000);
}
function formatMonth(monthIdx) {
  return months[monthIdx];
}
function formatWeekDay(idx) {
  return weekDays[idx];
}
function formatDate(date) {
  return date.getDate() + " de " + formatMonth(date.getMonth()) + " de " + date.getFullYear();
}
function formatCompactDate(isoDate) {
  var f = function f(num) {
    return num < 10 ? "0" + num : num;
  };
  var date = isoDate && typeof isoDate == "string" ? new Date(Date.parse(isoDate)) : isoDate && typeof isoDate == "object" ? isoDate : new Date();
  return "" + f(date.getDate()) + "/" + f(date.getMonth() + 1) + "/" + date.getFullYear();
}
function formatPhone(phone, separator) {
  separator = separator ? separator : " ";
  var finalPhone = phone.substring(0, 3);
  finalPhone += separator + phone.substring(3, 6);
  finalPhone += separator + phone.substring(6, 9);
  if (phone.length > 9) ;
  finalPhone += separator + phone.substring(9, 12);
  return finalPhone;
}
function formatPrice(rawPrice, fractionDigits) {
  fractionDigits = fractionDigits != undefined ? fractionDigits : 2;
  return rawPrice.toLocaleString("es-ES", {
    maximumFractionDigits: fractionDigits,
    minimumFractionDigits: fractionDigits
  });
}
function formatStars(rawStars) {
  return rawStars.toLocaleString("es-ES", {
    maximumFractionDigits: 1,
    minimumFractionDigits: 1
  });
}
function formatBidAvailability(availability) {
  var text;
  switch (availability) {
    case 0:
      text = "Menos de 24 horas";
      break;
    case 1:
      text = "Entre 24 y 48 horas";
      break;
    case 2:
      text = "Más de 48 horas";
      break;
    default:
      text = "No especificada";
      break;
  }
  return text;
}
function formatTransportationId(rawNumber, date) {
  var f = function f(num, digits) {
    return Math.floor(num).toLocaleString(undefined, {
      useGrouping: false,
      maximumFractionDigits: 0,
      minimumIntegerDigits: digits
    });
  };
  var month = date.getMonth() + 1;
  var year = date.getFullYear() % 100;
  return "TR-" + f(year, 2) + "-" + f(month, 2) + "-" + f(rawNumber, 4);
}
function formatDeliveryId(rawNumber, date) {
  var f = function f(num, digits) {
    return Math.floor(num).toLocaleString(undefined, {
      useGrouping: false,
      maximumFractionDigits: 0,
      minimumIntegerDigits: digits
    });
  };
  var month = date.getMonth() + 1;
  var year = date.getFullYear() % 100;
  return "DV-" + f(year, 2) + "-" + f(month, 2) + "-" + f(rawNumber, 4);
}
function formatFixedJobId(rawNumber, date) {
  var f = function f(num, digits) {
    return Math.floor(num).toLocaleString(undefined, {
      useGrouping: false,
      maximumFractionDigits: 0,
      minimumIntegerDigits: digits
    });
  };
  var month = date.getMonth() + 1;
  var year = date.getFullYear() % 100;
  return "PC-" + f(year, 2) + "-" + f(month, 2) + "-" + f(rawNumber, 4);
}
function formatRelativeGeneralDate(jobDate) {
  var currDate = new Date();
  currDate.setHours(0, 0, 0, 0);
  jobDate.setHours(0, 0, 0, 0);
  var millisDif = currDate.getTime() - jobDate.getTime();
  var daysDif = Math.trunc(millisDif / 86400000); // 1 day = 24 * 3600 * 1000 = 8.640.000 millis

  if (daysDif == 0) {
    //return precise ? formatRelativeGeneralTime(new Date(), new Date(Date.parse(isoDate))) : "hoy";
    return "hoy";
  } else if (daysDif == 1) {
    return "ayer";
  } else {
    return "hace " + daysDif + " días";
  }
}
function formatRelativeDate(date) {
  return "Subido " + formatRelativeGeneralDate(date, false);
}
function formatPaymentMethod(paymentMethod) {
  if (!paymentMethod) return "Desconocido";else switch (paymentMethod) {
    case "paycard":
      return "Tarjeta (Stripe)";
    case "tpv":
      return "Tarjeta (TPV)";
    case "cash":
      return "Efectivo";
    case "invoice":
      return "Factura";
    case "transfer":
      return "Transferencia";
    case "bricodepot":
      return "A cargo de BricoDepôt";
    case "business":
      return "A cargo de la empresa";
    case "funding":
      return "Financiación";
    case "total":
      return "Total";
    //Necesario para los albaranes, aunque no sea un método de pago real

    default:
      return paymentMethod;
  }
}